import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5d6235e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  width: "85",
  height: "33",
  viewBox: "0 0 85 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0.810528 16.4516V30.5669H14.4391V16.3543H8.20888C8.20888 11.2922 9.76643 8.27448 14.6338 6.52224V0.0973536C6.55398 1.26551 0.421141 8.07978 0.810528 16.4516ZM20.0852 16.4516V30.5669H33.7137V16.3543H27.4835C27.4835 11.2922 29.0411 8.27448 33.9084 6.52224V0.0973536C25.7313 1.26551 19.6958 8.27448 20.0852 16.4516Z",
  fill: "#fff"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M82.2692 14.1153V0H68.6407V14.2126H74.8708C74.8708 19.1773 73.216 22.2924 68.446 24.0446V30.4695C76.6231 29.204 82.6586 22.5844 82.2692 14.1153ZM62.9946 14.1153V0H49.366V14.2126H55.5962C55.5962 19.1773 53.9413 22.2924 49.1713 24.0446V30.4695C57.4458 29.3014 63.3839 22.3898 62.9946 14.1153Z",
  fill: "#fff"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3.24022 18.8847V33H16.8688V18.7874H10.6386C10.6386 13.7253 12.1961 10.7076 17.0635 8.95534V2.53046C8.98367 3.69862 2.85083 10.5129 3.24022 18.8847ZM22.5149 18.8847V33H36.1434V18.7874H29.9132C29.9132 13.7253 31.4708 10.7076 36.3381 8.95534V2.53046C28.161 3.69862 22.1255 10.7076 22.5149 18.8847Z",
  fill: "#5061FA"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M84.6989 16.5484V2.43311H71.0704V16.6457H77.3005C77.3005 21.6104 75.6456 24.7255 70.8757 26.4777V32.9026C79.0528 31.6371 85.0883 25.0176 84.6989 16.5484ZM65.4242 16.5484V2.43311H51.7957V16.6457H58.0259C58.0259 21.6104 56.371 24.7255 51.601 26.4777V32.9026C59.8755 31.7345 65.8136 24.8229 65.4242 16.5484Z",
  fill: "#5061FA"
}, null, -1))
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]


export default /*#__PURE__*/_defineComponent({
  name: 'DoubleQuote',
  props: {
    width: null,
    height: null,
    mobileWidth: null,
    mobileHeight: null
  },
  setup(__props: any) {

const props = __props as {
  width?: number;
  height?: number;
  mobileWidth?: number;
  mobileHeight?: number;
}

_useCssVars(_ctx => ({
  "8491330a": (getMobileWidth()),
  "173d01b4": (getMobileHeight())
}))



const getMobileWidth = () => {
  const target = props.mobileWidth || props.width || 85
  return `${target}px`
}

const getMobileHeight = () => {
  const target = props.mobileHeight || props.height || 33
  return `${target}px`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
}

})